import { render, staticRenderFns } from "./feedback.vue?vue&type=template&id=0c5e1b7a&scoped=true&"
import script from "./feedback.vue?vue&type=script&lang=ts&"
export * from "./feedback.vue?vue&type=script&lang=ts&"
import style0 from "./feedback.vue?vue&type=style&index=0&id=0c5e1b7a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5e1b7a",
  null
  
)

export default component.exports